import { cloneDeep } from 'lodash';
const INITIALIZE_ENVIRONMENT = "INITIALIZE_ENVIRONMENT";

const initialState = {
	serverDate: null,
	deployment: null,
	braintree: null
};

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case INITIALIZE_ENVIRONMENT:
			return action.payload;
		default:
			return state;
	}
}

export function environmentInitialize( environment, braintree_env ){
	return {
		type: INITIALIZE_ENVIRONMENT,
		payload: {
			serverDate: new Date(),
			deployment: environment || 'Staging',
			braintree: braintree_env
		}
	}
};


// WEBPACK FOOTER //
// ./src/modules/environment.js